if($('#userPartnersDatatable').length > 0) {
    url = $('#userPartnersDatatable').attr('data-url');
    dt = $("#userPartnersDatatable").DataTable({
        searchDelay: 2000,
        order: [[0, 'desc']],
        language: window.datatableLanguage,
        searching: true,
        serverSide: true,
        processing: true,
        responsive: true,
        ajax: url,
        select: {
            style: 'os',
            selector: 'td:first-child',
            className: 'row-selected'
        },
        columns: [
            {data: 'label'},
            {data: 'owner'},
            {data: 'partner_type'},
            {data: 'status'},
            {data: 'actions'},
        ],
        columnDefs: [
            {
                targets: 0,
                orderable: true
            },
            {
                targets: 1,
                orderable: true
            },
            {
                targets: 2,
                orderable: true
            },
            {
                targets: 3,
                orderable: true
            },
            {
                searchable : false,
                targets: 4,
                orderable: false
            }
        ]
    });

    const filterSearch = document.querySelector('[data-kt-table-filter-userpartnersdatatable="search"]');
    filterSearch.addEventListener('keyup', function (e) {
        dt.search(e.target.value).draw();
    });
}
